/** @jsx h */
import { h, render } from 'preact';
import Navigation from '../navigation/Navigation';

const rootElement = document.getElementById('spyscape-shared-nav');
const navElement = document.createElement('nav');
const { contentId, apiHost = '', alternateNavbarTheme } = rootElement.dataset;
rootElement.appendChild(navElement);

const init = () => {
  render(
    <Navigation
      contentId={contentId}
      apiHost={apiHost}
      alternateNavbarTheme={alternateNavbarTheme !== undefined}
    />,
    navElement,
  );
};

init();

if (module.hot) {
  module.hot.accept('../navigation/Navigation', init);
}
